/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateUserNoteAdminRequest } from '../models/CreateUserNoteAdminRequest';
import type { GetLatestUserNoteAdminResponse } from '../models/GetLatestUserNoteAdminResponse';
import type { Pagination1OfUserNoteAdminDto } from '../models/Pagination1OfUserNoteAdminDto';
import type { UpdateUserNoteAdminRequest } from '../models/UpdateUserNoteAdminRequest';
import type { UserNoteAdminDto } from '../models/UserNoteAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserNotesService {
    /**
     * **Required Policy:** `ViewCustomerNotes`
     * @returns UserNoteAdminDto OK
     * @throws ApiError
     */
    public static getUserNoteAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<UserNoteAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/usernotes/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCustomerNotes`
     * @returns UserNoteAdminDto OK
     * @throws ApiError
     */
    public static updateUserNoteAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: UpdateUserNoteAdminRequest,
    }): CancelablePromise<UserNoteAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/usernotes/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteCustomerNotes`
     * @returns UserNoteAdminDto OK
     * @throws ApiError
     */
    public static deleteUserNoteAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<UserNoteAdminDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/usernotes/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCustomerNotes`
     * @returns UserNoteAdminDto OK
     * @throws ApiError
     */
    public static getUserNotesByUserIdAdmin({
        userId,
    }: {
        userId: string,
    }): CancelablePromise<Array<UserNoteAdminDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/usernotes/users/{userId}',
            path: {
                'userId': userId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCustomerNotes`
     * @returns Pagination1OfUserNoteAdminDto OK
     * @throws ApiError
     */
    public static getUserNotesAdmin({
        userId,
        adminUserId,
        searchTerm,
        page,
        limit,
    }: {
        userId?: string,
        adminUserId?: string,
        searchTerm?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfUserNoteAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/usernotes',
            query: {
                'userId': userId,
                'adminUserId': adminUserId,
                'searchTerm': searchTerm,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCustomerNotes`
     * @returns UserNoteAdminDto OK
     * @throws ApiError
     */
    public static postUserNoteAdmin({
        requestBody,
    }: {
        requestBody?: CreateUserNoteAdminRequest,
    }): CancelablePromise<UserNoteAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/usernotes',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCustomerNotes`
     * @returns GetLatestUserNoteAdminResponse OK
     * @throws ApiError
     */
    public static getLatestUserNoteAdmin({
        userId,
    }: {
        userId: string,
    }): CancelablePromise<GetLatestUserNoteAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/usernotes/users/{userId}/latest',
            path: {
                'userId': userId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
